import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BilleteraService {
    public url: string;
    public NotaCredito: any;
    public eventoActualiazarVehiculo = new BehaviorSubject(false);
    public actualizarVehiculoXEsquema = this.eventoActualiazarVehiculo.asObservable();
    constructor(private _http: HttpClient, public jwtHelper: JwtHelperService) {
        this.url = environment.urlAddressHome;
    }

    obtenerSucursales() {
        const token = sessionStorage.getItem('token');
        const comercioID = sessionStorage.getItem('comercioID');
        return this._http.get(environment.urlAddressBilletera + 'comercioSucursal/listarComercioSucursalBilletera/' + comercioID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    actualizarSucursal(sucursal: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        sucursal.userID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioSucursal/actualizarComercioSucursalBilletera/', JSON.stringify(sucursal),
            {
                headers: httpHeaders
            }
        );
    }

    agregarSucursal(sucursal: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        sucursal.userID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioSucursal/agregarComercioSucursalBilletera/', JSON.stringify(sucursal),
            {
                headers: httpHeaders
            }
        );
    }

    obtenerUsuarios() {
        const token = sessionStorage.getItem('token');
        const comercioID = sessionStorage.getItem('comercioID');
        return this._http.get(environment.urlAddressBilletera + 'comercioUsuario/listarComercioUsuarioBilletera/' + comercioID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    actualizarUsuario(usuario: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        usuario.userID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioUsuario/actualizarComercioUsuarioBilletera/', JSON.stringify(usuario),
            {
                headers: httpHeaders
            }
        );
    }

    agregarUsuario(usuario: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        usuario.userID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioUsuario/agregarComercioUsuarioBilletera/', JSON.stringify(usuario),
            {
                headers: httpHeaders
            }
        );
    }

    obtenerPerfiles() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.get(environment.urlAddressBilletera + 'comercioUsuarioPerfil/listarComercioUsuarioPerfilesBilletera',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    obtenerServicios(comercioID) {
        const token = sessionStorage.getItem('token');
        return this._http.get(environment.urlAddressBilletera + 'servicios/listar/' + comercioID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    agregarServicio(servicio: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        servicio.usuarioID = usuarioID;
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressBilletera + 'servicios/agregar/', JSON.stringify(servicio),
            {
                headers: httpHeaders
            }
        );
    }

    actualizarServicio(servicio: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        servicio.usuarioID = usuarioID;
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressBilletera + 'servicios/actualizar/', JSON.stringify(servicio),
            {
                headers: httpHeaders
            }
        );
    }

    ReporteVendedor(servicio: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressBilletera + 'reporteBilletera/ventasPorVendedor/', JSON.stringify(servicio),
            {
                headers: httpHeaders
            }
        );
    }

    repoteVentas(inicio, fin) {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressBilletera + 'reportes/ventas/' + sessionStorage.getItem('comercioID') + '/' + inicio + '/' + fin,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    obtenerVentas() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.get(environment.urlAddressBilletera + 'comercioVenta/listarComercioVentaBilletera/' + usuarioID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    buscarClientexPlaca(placa: string) {
        const busqueda = {
            placa: placa
        }
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioVenta/obtenerComercioVentasClienteXPlaca/', JSON.stringify(busqueda),
            {
                headers: httpHeaders
            }
        );
    }

    buscarConductorxCedulaPlaca(placa: string, numeroDocumento: string) {

        const busqueda = {
            placa: placa,
            numeroDocumento: numeroDocumento
        }

        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioVenta/obtenerComercioVentasConductorXCedulaPlaca/', JSON.stringify(busqueda),
            {
                headers: httpHeaders
            }
        );
    }
  
    agregarVenta(venta: any) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        venta.usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'comercioVenta/agregarComercioVentaBilletera/', JSON.stringify(venta),
            {
                headers: httpHeaders
            }
        );
    }

    verificarOtp(totp) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        totp.usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressSecurity + 'validarCodigo/', JSON.stringify(totp),
            {
                headers: httpHeaders
            }
        );
    }

    verificarOtpConductor(totp) {
        const token = sessionStorage.getItem('token');
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });
        totp.usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.post<any>(environment.urlAddressSecurity + 'validarCodigoConductor/', JSON.stringify(totp),
            {
                headers: httpHeaders
            }
        );
    }

    cancelarVenta(ventaID) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        return this._http.get(environment.urlAddressBilletera + 'comercioVenta/cancelarComercioVentaBilletera/' + ventaID + '/2/&',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    cambiarPermiso(permiso) {
        const token = sessionStorage.getItem('token');
        permiso.comercioID = sessionStorage.getItem('comercioID');
        return this._http.post<any>(environment.urlAddressBilletera + 'permisos/cambiar/', permiso, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        })
    }

    obtenerPermisos(perfilID) {
        const token = sessionStorage.getItem('token');
        const comercioID = sessionStorage.getItem('comercioID');
        return this._http.get<any>(environment.urlAddressBilletera + 'permisos/obtener/' + comercioID + '/' + perfilID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        })
    }

    obtenerAcciones() {
        const token = sessionStorage.getItem('token');
        return this._http.get<any>(environment.urlAddressBilletera + 'permisos/obtenerAcciones/', {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        })
    }

    cambioPassword(passwordAnterior: string, passwordNueva: string) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.put(environment.urlAddressBilletera + 'cambiarClave', {
            usuarioID,
            password: passwordAnterior,
            passwordNueva
        },
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }
    obtenerComercioCategorias() {
        const token = localStorage.getItem('token');

        return this._http.get(environment.urlAddressBilletera + 'Billetera/listarComercioCategoriasBilletera/',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
 }


}